import createLocationModel from './lib/create_location_model';

export default createLocationModel({
  modelName: 'ApiTokens',
  properties: {},

  statics: {
    breadcrumb: 'API Tokens',
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/location/api_tokens.js